import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { NgxElectronModule } from 'ngx-electron';
import { NgxStripeModule } from 'ngx-stripe';
import { TimeagoModule } from 'ngx-timeago';
import { Angular4PaystackModule } from 'angular4-paystack';
import { environment } from '../environments/environment';
import { JSHINT } from 'jshint';
(window as any).JSHINT = JSHINT;
/*
 * ./services
 */
import { PouchService } from './services/pouch-service'; // General Database Service
import { PreviousRouteService } from './services/previous-route-service';
import { ImageService } from './services/image';
import { ChartService } from './services/chart';
import { Functions } from './services/functions';
import { EmojiProvider } from './services/emoji';
import { AddSettingPageModule } from './add-setting/add-setting.module';
import { AddEntityPageModule } from './add-entity/add-entity.module';
import { ReportPageModule } from './reports/reports.module';
import { JsonEditorPageModule } from './jsoneditor/jsoneditor.module';
import { CountdownModule } from 'ngx-countdown';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons'; //Solid icons
import { far } from '@fortawesome/free-regular-svg-icons'; // Regular icons
import { fab } from '@fortawesome/free-brands-svg-icons'; // Brand icons
import { PrintReceiptPageModule } from './print-receipt/print-receipt.module';
import { PrintEntityPageModule } from './print-entity/print-entity.module';
import { PrintDrugLabelPageModule } from './print-drug-label/print-drug-label.module';

const firebaseConfig = {
  apiKey: 'AIzaSyCh1apaVaaOR2w-hclYibEOY2Fa-lVubcE',
  authDomain: 'saru-tech.firebaseapp.com',
  databaseURL: 'https://saru-tech.firebaseio.com',
  projectId: 'saru-tech',
  storageBucket: 'saru-tech.appspot.com',
  messagingSenderId: '118779350897',
  appId: '1:118779350897:web:d9e24bc9da4ae3d772b0d0',
  measurementId: 'G-K777JVR3L5',
};

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgxElectronModule,
    CountdownModule,
    NgxStripeModule.forRoot('pk_live_r4YrMdde7YVDNKOnXS4b42f7'),
    Angular4PaystackModule.forRoot(environment.paystack.production),
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    IonicModule.forRoot(),
    TimeagoModule.forRoot(),
    AddSettingPageModule,
    AddEntityPageModule,
    PrintReceiptPageModule,
    PrintEntityPageModule,
    PrintDrugLabelPageModule,
    ReportPageModule,
    JsonEditorPageModule,
    FontAwesomeModule,
  ],
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }, ChartService, Functions, PouchService, PreviousRouteService, ImageService, EmojiProvider],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas, far, fab);
  }
}
